import React from 'react';
import ManageReviewTable from '../components/dashboard/ManageReviewTable';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import ModalMenu from '../components/Modal/ModalMenu';
import ModalSearch from '../components/Modal/ModalSearch';
import Scrollup from '../components/Scrollup/Scrollup';



const ManageReview = () => {

   

    
        return (

            <div className="main">
                <Header />
               <ManageReviewTable/>
                <Footer/>
                <ModalSearch />
                <ModalMenu />
                <Scrollup />
            </div>

            
        );
    }


export default ManageReview;